// @noflow
import type { Language } from '@/packs/localisation'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { DiscountBasis } from '@/utils/butternutbox/discountCodes'
import { UserType } from '@/utils/wizardCtaLink'

import Cta from './components/CTA'
import DogDetailsForm from './components/DogDetailsForm'
import Plan from './components/Plan'
import withApollo from '@/components/apollo/withApollo'
import Image from '@/components/shared/elements/Image/Image'

import type { Code as CountryCode } from '@/shared_types/rails_models/shipping_countries'

type Props = {
  preferredLanguage: Language
  currentUserType?: UserType
  screenIdentifier: string
  discountValue: number
  discountBasis: DiscountBasis
  shippingCountryCode: CountryCode
}

type DogDetails = {
  age: number
  weight: string | number
  interactedWithAge: boolean
}

const namespace = 'homepage'
const copyContext = 'rough_cost_calculator'
const baseClass = 'rough-cost-calculator__cost-calculator-card'

const RoughCostCalculatorCard = ({
  preferredLanguage,
  currentUserType,
  screenIdentifier,
  discountValue,
  discountBasis,
  shippingCountryCode
}: Props): JSX.Element | null => {
  const { t } = useTranslation(namespace)

  return (
    <>
      <div className={`${baseClass}__text-wrapper`}>
        <DogDetailsForm />
        <div className={`${baseClass}__plan-row`}>
          <Plan
            description={t(`${copyContext}.fresh_butternut`)}
            planType="bowl"
            copyContext={copyContext}
            namespace={namespace}
            preferredLanguage={preferredLanguage}
            shippingCountryCode={shippingCountryCode}
            discountValue={discountValue}
            discountBasis={discountBasis}
          />
        </div>
        <Cta
          namespace={namespace}
          text={`${copyContext}.build_your_box`}
          currentUserType={currentUserType}
          screenIdentifier={screenIdentifier}
        />
      </div>
      <div className={`${baseClass}__image-wrapper`}>
        <Image
          alt={t(`${copyContext}.image_alt`)}
          slug="rcc-alternative-image"
          image={{
            width: 326,
            height: 244
          }}
          className={`${baseClass}__image-wrapper__image`}
        />
      </div>
    </>
  )
}

export { Props }
export type { DogDetails }
export default withApollo(RoughCostCalculatorCard)
